export const STORAGE_KEYS = {
  INVESTOR_TYPE_V2: 'se_investor_type_v2',
  RECENTLY_VIEWED_V2: 'recently_viewed_offerings_v2',
  HOMEPAGE_V2_OVERRIDE: 'se_homepage_v2_override',
  PRIVATE_PAGE_V2_OVERRIDE: 'se_private_page_v2_override',
};

export const COOKIE_KEYS = {
  PREDICTED_EXPERIENCE: 'se_predicted_experience',
  VISITED_PRIVATE: 'se_visited_private',
  EXTERNAL_REFERER: 'se_external_referer',
};
